const initialState={}
export const AppReducer = (state=initialState, { action, payload }) => {
    switch (action) {
        default:return state
    }
}